/**
 * Auth Service Factory
 * Returns the appropriate auth service based on configuration
 */

import { IAuthService } from './IAuthService';
import { LocalAuthService } from './LocalAuthService';
import { CognitoAuthService } from './CognitoAuthService';
import { isCognitoEnabled } from '../../amplify-config';

/**
 * Singleton auth service instance
 * Automatically selects Local or Cognito implementation based on config
 */
export const authService: IAuthService = isCognitoEnabled
  ? new CognitoAuthService()
  : new LocalAuthService();
